import { defineStore } from 'pinia'
import {
  API_HEADER_STORE_ID,
  API_HEADER_HOST,
  API_HEADER_X_FORWARDED_HOST,
} from '../constants'

export const useHeaderStore = defineStore(API_HEADER_STORE_ID, {
  state: () => ({
    [API_HEADER_HOST]: '',
    [API_HEADER_X_FORWARDED_HOST]: '',
  }),
  getters: {
    isApp: state => {
      const runtimeConfig = useRuntimeConfig()
      return state[API_HEADER_HOST]?.includes(
        runtimeConfig.public.NATIVE_APP_HOST,
      )
    },
    isMobileApp: state => {
      const runtimeConfig = useRuntimeConfig()
      return state[API_HEADER_HOST]?.includes(
        runtimeConfig.public.MOBILE_APP_HOST,
      )
    },
  },
  actions: {
    setHost(newHost: string) {
      this[API_HEADER_HOST] = newHost
    },
    setXForwardedHost(newHost: string) {
      this[API_HEADER_X_FORWARDED_HOST] = newHost
    },
  },
})
